import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FiArrowUpRight, FiUsers } from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import AuthForm from './components/AuthForm';
import './App.css';

function App() {
  const [mode, setMode] = useState('login');

  return (
    <main className="page-shell">
      <section className="auth-card" aria-label="DEL Young Leaders Connect">
        <div className="form-panel">
          <a className="brand" href="#home" aria-label="DEL Young Leaders home">
            <span className="brand-mark"><SafeIcon icon={FiUsers} /></span>
            <span className="brand-name">DEL <b>YOUNG LEADERS</b></span>
          </a>

          <div className="form-content">
            <div className="eyebrow"><span /> YOUR COMMUNITY, CONNECTED</div>
            <h1>{mode === 'login' ? 'Welcome back.' : 'Join the community.'}</h1>
            <p className="intro">
              {mode === 'login'
                ? 'Sign in to connect with the people and opportunities that move you forward.'
                : 'Create an account to meet ambitious people and discover what’s next.'}
            </p>

            <div className="mode-switch" role="tablist" aria-label="Account options">
              <button
                type="button"
                role="tab"
                aria-selected={mode === 'login'}
                className={mode === 'login' ? 'active' : ''}
                onClick={() => setMode('login')}
              >
                Sign in
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={mode === 'signup'}
                className={mode === 'signup' ? 'active' : ''}
                onClick={() => setMode('signup')}
              >
                Create account
              </button>
            </div>

            <AnimatePresence mode="wait">
              <motion.div
                key={mode}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -6 }}
                transition={{ duration: 0.2 }}
              >
                <AuthForm mode={mode} />
              </motion.div>
            </AnimatePresence>
          </div>

          <p className="panel-footer">A place to grow, contribute, and lead.</p>
        </div>

        <aside className="story-panel">
          <div className="story-orbit orbit-one" />
          <div className="story-orbit orbit-two" />
          <div className="story-topline"><span>THE NEXT GENERATION</span><span>01 — 03</span></div>
          <div className="story-copy">
            <div className="story-symbol"><SafeIcon icon={FiUsers} /></div>
            <p className="story-kicker">MORE THAN A NETWORK</p>
            <h2>Big ideas grow better <em>together.</em></h2>
            <p className="story-description">
              Find your people, share what you know, and make room for what’s possible.
            </p>
            <a className="story-link" href="#community">
              Discover the community <SafeIcon icon={FiArrowUpRight} />
            </a>
          </div>
          <div className="story-note">
            <span className="note-dot" />
            <span>For curious minds and future leaders.</span>
          </div>
        </aside>
      </section>
      <p className="page-caption">DEL YOUNG LEADERS <span>·</span> CONNECT</p>
    </main>
  );
}

export default App;